export default {
  lang: 'uz',

  nav: {
    home:    'kodni kiriting',
    prizes:  'Sovrinlar',
    about:   'Aksiya haqida',
    faq:     'Yordam',
    profile: 'Profil',
  },

  codePage: {
    title:              'Aksiya yakunlandi',
    subtitle:           'Ko\'proq kodni ro\'yxatdan o\'tkazing va sovrinlarni qo\'lga kiritish imkoniyatingizni oshiring!',
    placeholder:        'Kodni kiriting',
    placeholderAnother: 'Boshqa kodni kiriting',
    mainImg: new URL('../assets/img/main_img_uz_3.webp', import.meta.url).href,
  },

  playPage: {
    title:          'Kod ro\'yxatga olindi',
    subtitle:       'Javonlarni oching – sovrinlarni qo\'lga kiriting',
    spinBtn:        'Javonni ochish',
    spinning:       'Aylanmoqda...',
    won:            ' ',
    claimBtn:       'Получить приз',
    btnEnterCode:   'Boshqa kodni kiriting',
    btnMoreDetails: 'Batafsil',
    btnEnterName:   'Ismingizni kiriting',
    btnMerchandiseDetails:   'Buyurtmani olib ketish punktini tanlang',
    emptyPrizeDesc: 'Super sovrinlarni yutib olish imkoniyatini qo\'lga kiritdingiz',
  },

  customizationPage: {
    title:         'Ismingizni kiriting',
    placeholder:   'Ismingizni kiriting',
    label:         'Ismingizni kiriting',
    ariaShowFront: 'Old tomonini ko\'rsatish',
    ariaShowBack:  'Orqa tomonini ko\'rsatish',
    sizesBtn:      'O\'lchamlar jadvali',
    nextBtn:       'Davom etish',
  },

  deliveryPage: {
    title:               'Ma\'lumotlarni kiriting',
    fullNamePlaceholder: 'Oluvchining ismi-sharifi',
    fullNameLabel:       'Oluvchining ismi-sharifi',
    phoneLabel:          'Oluvchining telefon raqami',
    addressTitle:        'Yetkazib berish manzili',
    changeAddress:       'Manzilni o\'zgartirish',
    selectPickup:        'Buyurtmani olib ketish punktini tanlang',
    confirmBtn:          'Tasdiqlash',
    phoneErrorEmpty:     'Telefon raqamini kiriting',
    phoneErrorInvalid:   'Noto\'g\'ri raqam',
  },

  claimPage: {
    title:             'Qabul qilishni rasmiylashtirish',
    fullName:          'Ism va familiya',
    phone:             'Oluvchining telefon raqami',
    email:             'Email',
    pickupTitle:       'Buyurtmani olib ketish punktini tanlang',
    selectPoint:       'Выбрать на карте',
    submit:            'Tasdiqlash',
    success:           'Arizangiz qabul qilindi! Siz bilan bog\'lanamiz',
    mapLoading:        'Xarita yuklanmoqda...',
    noPoints:          'Berish punktlari topilmadi',
    searchTitle:       'Qidirish',
    searchPlaceholder: 'Xaritada qidirish',
    labelIndex:        'Indeks',
    labelAddress:      'Pochta aloqasi bo\'limi',
    pickupBtn:         'Shu yerdan olib ketaman',
    labelLandmark:     'Mo \‘ljal',
  },

  prizePage: {
    title:        'Sovrinlar',
    subtitle:     'Все призы, которые можно выиграть',
    empty:        'Призы скоро появятся',
    weeklyTitle:  'Har hafta oʻynaladigan sovrinlar',
    dailyTitle:   'Kundalik sovrinlar',
    carName:      'BYD YUAN UP avtomobili',
    carModel:     '',
    consoleName:  'PLAYSTATION 5 PRO',
    consoleModel: '',
    vietnamName:   'VETNAMGA SAYOHAT',
    tshirtName:   'Ismingiz tushirilgan futbolka',
    certName:     'Setanta Sports sertifikati',
    mainImg:    new URL('../assets/img/prizes/prize_every_weekly_uz.webp', import.meta.url).href,
    detailsBtn:   'Batafsil',
    tshirtDetail: {
      name:        'ISMINGIZ TUSHIRILGAN 12-RAQAMLI O‘YINCHI FUTBOLKASI',
      description: 'Unga ega bo \‘lish orqali siz butun mamlakatimizni qamrab oladigan 12-raqamli o \‘yinchilarning noyob jamoasi a \’zosiga aylanasiz. \n \n Ismingizni yozing, o \‘lchamni tanlang, yetkazib berishni rasmiylashtiring – biz esa ismingiz tushirilgan futbolka sizga yetib borishini ta \'zimimizga’minlaymiz. ⚽🔥',
    },
    certDetail: {
      name:        'Setanta Sports striming platformasiga 1 oylik obuna',
      description: 'Pepsi Football aksiyasi doirasida ishtirokchilar eksklyuziv sport kontentidan foydalanish imkonini beruvchi Setanta Sports striming platformasiga obuna bo\'lish uchun promokod yutib olishlari mumkin. \n Platformada futbol chempionatlari (Angliya Premyer Ligasi, A Seriya, Liga 1, Bundesliga, La Liga), UFC, Formula-1, NBA, NHL, tennis va boshqa ommabop sport tadbirlarining jonli translyatsiyalari namoyish etiladi.',
    },
    beachDetail: {
      name:        'VYETNAMGA SAYOHAT',
      description: 'Sertifikat ikki kishi uchun Vyetnamga turistik sayohat qilish imkoniyatini taqdim etadi. \n \n Sertifikatdan foydalanish uchun 31.12.2026 sanasigacha shartnoma tuzish, sayohatni esa 31.12.2027 sanasigacha amalga oshirish kerak. Sayohat sanalarini g‘olib bo‘sh o‘rinlar va aviareyslar mavjudligini inobatga olgan holda mustaqil ravishda tanlaydi.',
    },
    done: 'dan',
  },

  aboutPage: {
    title:          'Pepsi bilan \n o\'yinda bo\'ling!',
    subtitle:       '2026-yil 22-maydan 23-avgustgachа',
    textLink:       'Ishtirok etish haqida batafsil',
    watchLink:       'Tomosha qil!',
    textMorePizes:  'va boshqa ko\'plab mukofotlar',
    prizeEveryday:  'Har kuni 22-maydan \n 22-avgustgacha quyidagi sovrinlarni o \‘yinga qo \‘yamiz:',
    prizeEveryweek: 'Sovrinlar yutib olish imkoniyatini qo\'lga kiriting',
    rulesTitle:     'Aksiyada qanday ishtirok etish mumkin?',
    step1Label:     '1-qadam',
    step1Text:      'Aksiyadagi sariq qopqoqli Pepsi xarid qiling',
    step2Label:     '2-qadam',
    step2Text:      'Qopqoq ostidagi kodni kiriting',
    step3Label:     '3-qadam',
    step3Text:      'Sovrinli chambarakni ishga tushiring va sovrinli o\'yinlarda qatnashing',
    step3Img: new URL('../assets/img/about/step_3_uz.png', import.meta.url).href,
    tshirtName:  'Ismingiz tushirilgan 12-raqamli o‘yinchi futbolkasi',
    certName:    'Setanta Sports striming platformasiga 1 oylik obuna',
    ballName:    'Futbol to \'pi',
    bagName:     'Termo sumka',
    cupName:     'Stakan-Xameleon',
    scarfName:   'Brendlangan sharf',
    uzumName:    '10 000  so\'mlik UZUM, 25 000 va 50 000  so\'mlik',
    uzumName10:    '10 000 so\'mlik UZUM',
    uzumName25:    '25 000 so\'mlik UZUM',
    uzumName50:    '50 000 so\'mlik UZUM',
    carName:     'BYD Yuan Up avtomobili',
    consoleName: 'Sony PlayStation 5 oʻyin qurilmasi',
    bichName:    'Vetnamga sayohat qilish uchun sertifikat',
    watchingName:    'Har yakshanba soat 19:30 \n da jonli efirda qur’a tashlash.',
    uzumImg: new URL('../assets/img/prizes/prize_uzum_uz.webp', import.meta.url).href,
    uzumImg10: new URL('../assets/img/prizes/prize_uzum_uz_10.webp', import.meta.url).href,
    uzumImg25: new URL('../assets/img/prizes/prize_uzum_uz_25.webp', import.meta.url).href,
    uzumImg50: new URL('../assets/img/prizes/prize_uzum_uz_50.webp', import.meta.url).href,
    weekendImg: new URL('../assets/img/prizes/prize_every_weekend_uz.webp', import.meta.url).href,
  },

  faqPage: {
    title:          'Yordam',
    empty:          'Savollar tez orada',
    footerQuestion: 'Savolingizga javob topmadingizmi?',
    footerAnswer:   'Mini-ilovadan chiqing va botdagi \'Yordam\' bo\'limi orqali bizga xabar yuboring',
  },

  profilePage: {
    title:       'profil',
    noAuth:      'Siz tizimga kirmagansiz',
    prizes:      'Yutib olingan sovrinlar',
    noPrizes:    'Hozircha sovrinlar yo\'q',
    codesTitle:  'Mening kodlarim',
    prizesTitle: 'Yutib olingan sovrinlar',
    openBtn:     'Ochish',
    openTitle:   'Javonlarni oching va sovrinlarni yutib oling',
    copyTitle:   'Nusxalash',
    copiedText:  'Nusxalandi',
    noCodes:     'Siz hali birorta ham kodni ro‘yxatdan o\ ‘tkazmagansiz',
    noPrizes:    'Sizda hali sovrin yo\ ‘q',
  },

  certPage: {
    title:         'Setanta Sports sertifikati',
    copyTitle:     'Nusxalash',
    copiedText:    'Nusxalandi',
    promoDate:     'Promokodning amal qilish muddati: 2026-yil 22-maydan 18-oktyabrgacha',
    newSubTitle:   'Agar faol obunangiz bo\'lmasa va uni promokod yordamida xarid qilmoqchi bo\'lsangiz',
    newSubSteps: [
      'Brauzeringizda <a href="https://app.setantasports.com/home" target="_blank">app.setantasports.com →</a> ni oching',
      'Ro\'yxatdan o\'tishda ko\'rsatilgan elektron pochta manzilingiz va parolingiz bilan kiring',
      'Ekraning yuqori o\'ng burchagidagi Akkaunt tugmasini bosing',
      '«Obunalar» bo\'limiga o\'ting va keraklisini tanlang',
      '«To\'lov usuli» qismida bank kartasini tanlang hamda karta raqami, amal qilish muddati va kartaning orqa tomonidagi uch xonali CVC-kodni kiriting',
      'Promokodni tegishli maydonga kiriting va «Qo\'llash» tugmasini bosing',
      '«Buyurtmani rasmiylashtirish» tugmasini bosing va obunangiz faollashtiriladi',
    ],
    existSubTitle: 'Agar faol obunangiz bo\'lsa va promokoddan keyingi to\'lov paytida foydalanmoqchi bo\'lsangiz.',
    existSubSteps: [
      'Brauzeringizda <a href="https://app.setantasports.com/home" target="_blank">app.setantasports.com →</a> ni oching',
      'Ro\'yxatdan o\'tishda ko\'rsatilgan elektron pochta manzilingiz va parolingiz bilan avtorizatsiyadan oʻting',
      'Ekraning yuqori o\'ng burchagidagi Akkaunt tugmasini bosing',
      '«Obunalar» bo\'limiga o\'ting',
      'Faol obunangiz bo\'lsa, «Promokodni qo\'llash» tugmasini bosing',
      'Promokodni kiriting va «Yuborish» tugmasini bosing',
    ],
  },

  modals: {
    sizeChartTitle:   'Oʻlchamlar jadvali',
    sizeLabel:        'Oʻlcham',
    chestLabel:       'Ko\'krak qafasi aylanasi, sm',
    waistLabel:       'Bel aylanasi, sm',
    copyTitle:        'Nusxalash',
    copiedText:       'Nusxalandi',
    tshirtModalTitle: 'Ismingiz tushirilgan futbolka',
    compositionLabel: '-',
    compositionValue: '-',
    trackLabel:       'Trek raqami',
    trackCopied:      'Trek raqami nusxalandi',
    pickupLabel:      'Pochta aloqasi boʻlimi',
  },

  prizeCard: {
    detailsBtn:       'Batafsil',
    addAddressBtn:    'Manzil qoʻshish',
    enterNameBtn:     'Ismingizni kiriting',
    moderationReason: 'Rad etilganlik sababi',
    statuses: {
      delivered:                 'Yetkazib berildi',
      customization_required:    'Ma \'lumotlarni kiriting',
      moderation_pending:        'Moderatsiyada',
      moderation_approved:       'Yetkazib berishga topshirildi',
      delivery_pending:           'Yetkazib berishga topshirildi',
      moderation_declined:       'Rad etildi',
      address_required:          'Ma \'lumotlarni kiriting',
      delivery_created:          'Yetkazib berishga topshirildi',
      sent_to_production:        'Yetkazib berishga topshirildi',
      in_transit:                'Yetkazilmoqda',
      ready_for_pickup:          'Topshirishga tayyor',
      delivery_failed:           'Yetkazib berishda xatolik',
      cancelled:                 'Bekor qilindi',
    },
  },

  common: {
    loading:    'Yuklanmoqda...',
    error:      'Xatolik yuz berdi. Keyinroq urinib ko\'ring.',
    back:       'Orqaga',
    close:      'Yopish',
    copyTitle:  'Nusxalash',
    copiedText: 'Nusxalandi',
  },

  error: {
    codePageTitle: 'Xatolik yuz berdi',
    notUserTitle:  'Faqat ro\'yxatdan o\'tgan foydalanuvchilar uchun',
    warningCode: {
      title:   'Xatolik yuz berdi',
      btnText: 'Qayta urinib ko\'rish',
    },
    warningSpin: {
      title:   'Nimadir xato ketdi',
      btnText: 'Qayta urinib ko\'rish',
    },
    errorCustom: {
      title:     'Nimadir xato ketdi',
      message:   'Iltimos, futbolkadagi yozuvlar qoidalarga muvofiqligini tekshiring',
      linkRules: 'Qoidalar',
      btnText:   'Qayta urinib ko\'rish',
    },
    errorAddress: {
      title:   'Nimadir xato ketdi',
      message: 'Kiritilgan ma\'lumotlarni tekshiring va qayta urinib ko\'ring',
      btnText: 'Ma\'lumot kiritishga qaytish',
    },
    codeOutcome: {
      already_used:       'Bu kod allaqachon ishlatilgan',
      not_found:          'Kod topilmadi. Kiritilgan ma\'lumotni tekshiring',
      blocked:            'Kod bloklangan',
      tooManyAttempts:    'Juda ko\'p urinish. Keyinroq urinib ko\'ring',
      daily_limit_reached: 'Kunlik limit oshib ketdi. Ertaga qaytib keling.',
    },
  },

  success: {
    title:        'Arizangiz yuborildi',
    subtitle:     '«{name}» tekshiruvga yuborildi, natijasi 72 soat ichida ma\'lum bo\'ladi',
    defaultName:  'Sovrin',
  },
  successMerch: {
    title:        'BUYURTMA MUVAFFAQIYATLI RASMIYLASHTIRILDI',
    subtitle:     'Holatini shaxsiy kabinetingizda kuzatib boring',
  },
  stockStatus: {
    notStartedTitle:    'Aksiya hali boshlanmagan',
    endedTitle:    'Aksiya yakunlandi',
  },
}
